<div class="data-table-container modal-container">
    <div *ngIf="loading" class="m-auto">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Loading...</p>
    </div>

    <div class="flex flex-space-between">
        <div class="head-font">{{actionHeadText}}</div>
        <mat-icon class="close-icon cursor-pointer" (click)="dialogRef.close(false)"
                  aria-hidden="false"
                  aria-label="close icon"
                  iconPositionEnd
                  mat-dialog-close>close
        </mat-icon>
    </div>

    <div class="subhead-font">{{tourOperator?.Name}}</div>
    <div *ngIf="selectedAction === OperatorActionType.Request || selectedAction === OperatorActionType.Reject" class="reason-head">
        Reason
    </div>

    <textarea class="reason-text t-area" *ngIf="selectedAction === OperatorActionType.Request || selectedAction === OperatorActionType.Reject"
              rows="5" cols="30" maxlength="200" pInputTextarea [(ngModel)]="actionText" placeholder="Specify changes needed"></textarea>

    <div class="reason-text" *ngIf="selectedAction === OperatorActionType.Request">
        This comment will be sent to the operator and recorded in the audit trail.
    </div>

    <div class="flex justify-content-end mt-2 pt-1">
        <button mat-dialog-close (click)="dialogRef.close(false)" class="btn-cancel-no-border btn-font btn-transparent">Cancel</button>
        <button (click)="applyAction()" [ngStyle]="{ 'background-color': actionBtnColor }" class="btn-default btn-font ml-3">{{actionBtnText}}</button>
    </div>
</div>
